import { useNavigate } from "react-router-dom";
import { Pencil } from "lucide-react";
import { setAdminFocus, NOTE_TAB } from "@/lib/adminFocus";

const isAdmin = () => { try { return !!localStorage.getItem("islasol_token") && localStorage.getItem("islasol_role") === "admin"; } catch { return false; } };

/** Schwebender „Bearbeiten“-Knopf (nur für angemeldete Admins): springt direkt ins passende Admin-Formular. kind = property|complex|island|place|region|page|home */
export const AdminEditButton = ({ kind, id, label = "Als Admin bearbeiten", active }) => {
  const nav = useNavigate();
  if (!isAdmin()) return null;
  const tab = kind === "home" ? "settings" : NOTE_TAB[kind];
  const go = () => { if (id) setAdminFocus(kind, id); nav(`/admin?tab=${tab}`); };
  const status = active === undefined ? "" : active ? " · Online" : " · Offline";
  return (
    <button type="button" onClick={go} title={`${label}${status}`}
            className="fixed top-[76px] right-5 z-[55] inline-flex items-center gap-2 rounded-full bg-[#2d6b0d] text-white pl-3 pr-4 py-2 shadow-lg shadow-black/20 hover:bg-[#245609] hover:-translate-y-0.5 transition-[transform,background-color] print:hidden"
            data-testid="admin-edit-btn" data-kind={kind}>
      <Pencil className="w-4 h-4" />
      <span className="text-sm font-medium">Bearbeiten</span>
      {active !== undefined && <span className={`w-2 h-2 rounded-full ${active ? "bg-emerald-300" : "bg-stone-300"}`} title={active ? "Online" : "Offline"} />}
    </button>
  );
};
